// Client-side allowlist of email domains permitted to create new accounts.
//
// Note that as this is only enforced in the frontend, it's theoretically possible
// to bypass by hitting the Firebase Auth API directly. An 80/20 solution is fine
// here though, we just want to avoid random signups that create support burden
// and most people will likely close the tab when they see the error message
// during signup.
const ALLOWED_SIGNUP_DOMAINS = new Set([
  'fetch.com',
  'fetchrewards.com',
  'jolly.com',
  'rye.com',
  'wealthsimple.com',
  'bilt.com',
  'biltrewards.com',
]);

export const SIGNUP_DOMAIN_ERROR =
  'Sign-ups are currently limited to approved enterprise customers only.';

export const isAllowedSignupEmail = (email: string | null | undefined): boolean => {
  const domain = email?.split('@')[1]?.trim().toLowerCase();
  return !!domain && ALLOWED_SIGNUP_DOMAINS.has(domain);
};
